module.exports = __webpack_public_path__ + "img/logo.ab57fd3e.svg";